export default __webpack_public_path__ + "static/media/Back.955de736.webp";